import React from "react";
import "../../styles/questionColumn.css";

const ALLOWED_REGEX = /^[0-9.\-\/]*$/;

const FillBlank = ({ value, onChange, disabled }) => {
  const handleChange = (e) => {
    const raw = e.target.value;

    // Enforce character set + max length
    if (!ALLOWED_REGEX.test(raw)) return;
    if (raw.length > 5) return;

    onChange(raw);
  };

  return (
    <div className="fill-blank-wrapper">
      {/* Input box */}
      <div className="fill-blank-box">
        <input
          type="text"
          value={value ?? ""}
          disabled={disabled}
          onChange={handleChange}
          className="fill-blank-input"
        />
        <div className="fill-blank-underline" />
      </div>

      {/* Answer Preview — ONLY for fill in blank */}
      <div className="fill-blank-preview">
        <strong>Answer Preview:</strong> <span>{value || ""}</span>
      </div>
    </div>
  );
};

export default FillBlank;
